import { useEffect, useState } from 'react';

import { styled } from '@mui/material';

import { Box, Typography, Modal } from '@app-velocity/ui';

import { getCoreVersion } from '../../../../core';

const StyledBuildVersion = styled(Typography)({
  color: 'var(--color-neutral-500)',
  fontSize: 11,
  fontWeight: 300,
});

const StyledLabel = styled(Typography)({
  color: 'var(--color-neutral-500)',
  fontSize: 11,
  fontWeight: 500,
  marginRight: 4,
  width: 35,
});

const StyledVersion = styled('div')({
  display: 'flex',
});

export const AboutModalContent = () => {
  const [coreVersion, setCoreVersion] = useState('');

  const getBuildCoreVersion = async () => {
    const version = await getCoreVersion();
    setCoreVersion(version);
  };

  useEffect(() => {
    getBuildCoreVersion();
  });

  return (
    <Modal>
      <Modal.Header title="shared:about" />
      <Modal.Content>
        <Box>
          <StyledVersion>
            <StyledLabel>UI:</StyledLabel>
            <StyledBuildVersion>{BUILD_VERSION}</StyledBuildVersion>
          </StyledVersion>
          <StyledVersion>
            <StyledLabel>CORE:</StyledLabel>
            <StyledBuildVersion>{coreVersion}</StyledBuildVersion>
          </StyledVersion>
        </Box>
      </Modal.Content>
    </Modal>
  );
};
